// @flow

import { selectPricingInfos } from '@gandi/billing';
import type { Grid, Currency } from '@gandi/billing';
import { selectMailboxPrice } from '@gandi/redux-resource-price';
import type { ProductPrice, MailboxType } from '@gandi/redux-resource-price';
import { selectCurrentId } from '@gandi/redux-sharing';

import { useAppSelector } from 'src/hooks/useAppSelector';

// MailboxPrice: missing export in @gandi/redux-resource-price
export type MailboxPrice = {
  ...ProductPrice,
  options: {},
};

type Args = {
  mailboxType: MailboxType,
  minDuration: number,
};

export default function useMailboxPrice({ mailboxType, minDuration }: Args): {
  currency: Currency,
  grid: Grid,
  price: MailboxPrice | void,
  sharingId: string,
} {
  const sharingId = useAppSelector(selectCurrentId);

  const { currency, grid } = useAppSelector(selectPricingInfos);

  const price = useAppSelector(state =>
    selectMailboxPrice(state, {
      process: 'create',
      productType: 'mailboxv2',
      sharingId,
      currency,
      grid,
      mailboxType,
      minDuration,
    }),
  );

  return {
    price,
    currency,
    grid,
    sharingId,
  };
}
